export default __webpack_public_path__ + "static/media/home_web-lg@2x.b0dfa6da.jpg";